/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

// 动态加载侧边栏方法
/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass (ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// echarts图表大小重新绘制相关
/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

// 转换日期格式
/**
 * @param {Date} input
*/
export function formatDateTime (input) {
  var d = new Date(input)
  var year = d.getFullYear()
  var month = d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1)
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
  var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
  var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
  var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
  return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)
}

// 转换日期格式
/**
 * @param {Date} input
*/
export function formatDateTimeMillSecond (input) {
  var d = new Date(input)
  var year = d.getFullYear()
  var month = d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1)
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
  var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
  var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
  var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
  // var millSeconds = d.getMilliseconds() < 1000 ? '0' + d.getMilliseconds() : '' + d.getMilliseconds()
  var millSeconds = d.getMilliseconds()
  return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds + '.' + millSeconds)
}



// WEBPACK FOOTER //
// ./src/utils/index.js